<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
  <div>
    <nav class="bar bar-nav">
      <h1 class="title">登录</h1>
    </nav>
    <div class="content" style="background: linear-gradient(#3B7EFE, #33CEFC);">
      <div class="list-block" style="margin-top: 3.5rem;">
        <ul class="ul">
          <li>
            <div class="item-content height">
              <div class="item-media"><i class="icon icon-form-name"></i></div>
              <div class="item-inner">
                <!--<div class="item-title label">帐号</div>-->
                <div class="item-input" @click="focus('account')">
                  <input type="text" id="account" v-model.trim="account" placeholder="手机/邮箱/帐号">
                </div>
              </div>
            </div>
          </li>
        </ul>
        <ul class="ul" v-if="isSalesFlag">
          <li>
            <div class="item-content height">
              <div class="item-media"><i class="icon icon-form-settings"></i></div>
              <div class="item-inner">
                <div class="item-input" @click="focus('sfaccount')">
                  <input v-bind:style="{color:error}" id="sfaccount" type="text" v-model.trim="customerNo" placeholder="客户编号">
                </div>
              </div>
            </div>
          </li>
        </ul>
        <ul class="ul">
          <li>
            <div class="item-content height">
              <div class="item-media"><i class="icon icon-form-password"></i></div>
              <div class="item-inner">
                <!--<div class="item-title label">密码</div>-->
                <div class="item-input" @click="focus('password')">
                  <input type="password" id="password" v-model.trim="password" placeholder="密码" >
                  <img v-show="password" @click="deletePassword" class="delete-password" src="/static/img/delete.png" />
                  <img v-if="showPassword" class="show-password" @click="toggleShowPassword" src="/static/img/display-password.png"/>
                  <img v-else class="show-password" @click="toggleShowPassword" src="/static/img/hide-password.png"/>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="content-block">
        <div class="row" style="margin-top: -2.4rem;margin-left: 0;text-align: center">
          <!--<div class="routerlink">-->
            <!--<router-link :to="{ name: 'activation' }"><span class="fontcolor">激活账户</span></router-link>-->
          <!--</div>-->
<!--          <div class="routerlink">-->
<!--            <router-link :to="{ name: 'forgetPassword', query: {fromFullPath: fromFullPath} }"><span class="fontcolor" style="margin-left: -1.6rem;">忘记密码</span></router-link>-->
<!--          </div>-->
<!--          <div class="routerlink">-->
<!--            <router-link :to="{ name: 'PhoneNumberLogin', query: {fromFullPath: fromFullPath} }"><span class="fontcolor" style="margin-left: -1.6rem;">手机短信登录</span></router-link>-->
<!--          </div>-->
<!--          <div class="routerlink" style="float: right">-->
<!--            <router-link :to="{ name: 'register' }"><span class="fontcolor" style="margin-right: -1.6rem;">用户注册</span></router-link>-->
<!--          </div>-->
        </div>
      </div>
      <div class="content-block">
<!--        <div class="row">-->
<!--          <div class="col-100" style="width: 92.5%;margin-left: 5.5%;">-->
<!--            <a @click="login" class="button button-big button-fill button-success btn" style="background-color: #fff;">-->
<!--              <span class="fontlogin">登录</span>-->
<!--            </a>-->
<!--          </div>-->
<!--        </div>-->
      </div>
      <div class="bottom">
        <div class="block3">
          <div class="left" onclick="window.open('https://beian.miit.gov.cn/')" target="_blank">沪ICP备17040580号-1</div>
          <div class="right">
            <img
              class="icon2"
              referrerpolicy="no-referrer"
              src="static/img/ba.png"
            />
            <span class="info3">沪公网安备&nbsp;31011502400053号</span>
          </div>
        </div>
      </div>
      </div>
  </div>
</template>

<script>
// client authentication here
// import md5 from 'js-md5'
import $ from 'jquery'
import EMKT from '../../../emkt.js'
import {mapState, mapMutations} from 'vuex'
import wx from 'wx'
export default {
  mounted () {
  },
  created () {
    this.hasLogin()
    this.isSales()
  },
  watch: {
    'customerNo': function (val) {
      let reg = /^\d{8}$/
      if (!reg.test(val)) {
        this.error = 'red'
        this.errorFlag = true
      } else {
        this.error = 'black'
        this.errorFlag = false
      }
    }
  },
  beforeRouteEnter (to, from, next) { // 若从活动页面跳转到登录页面，登录成功后返回活动页面
    console.log('to from ', to, from)
    next(vm => {
      if (from.fullPath && (from.fullPath.includes('ResearchGroup') || from.fullPath.includes('activity'))) {
        vm.fromFullPath = from.fullPath
      }
    })
  },
  data () {
    return {
      account: '',
      password: '',
      customerNo: '',
      isSalesFlag: false,
      error: '',
      errorFlag: false,
      showPassword: false,
      fromFullPath: '/me',
      isWapp: EMKT.isWapp
    }
  },
  computed: {
    ...mapState([
      'sessionInfo'
    ])
  },
  methods: {
    ...mapMutations([
      'UPDATE_RESEARCHGROUP_MEMBER_MAP', 'UPDATE_RESEARCHGROUP_SET', 'LOGIN_STATE_UPDATE', 'CLIENT_INFO', 'EXPRESSADDRESS_UPDATE', 'INVOICE_TITLE', 'MYORDER_UPDATE', 'INVOICE_ADDRESS', 'INIT_MESSAGE'
    ]),
    isSales () {
      let sales = this.getUrlParam('sales')
      if (sales === '1') {
        this.isSalesFlag = true
      }
    },
    getUrlParam (val) {
      var uri = window.location.href
      var re = new RegExp('' + val + '=([^&?]*)', 'ig')
      return ((uri.match(re)) ? (uri.match(re)[0].substr(val.length + 1).substring(0, 1)) : null)
    },
    hasLogin () {
      var _this = this
      let guest = _this.sessionInfo
      let customerInfo = _this.sessionInfo.customerInfo
      if (!(guest.customerNo === 'GUEST' || customerInfo === '')) {
        _this.goHome()
      }
    },
    goHome () {
      // todo return to home
      if (this.isWapp) {
        wx.miniProgram.switchTab({
          url: '/pages/my/my'
        })
      } else {
        this.$router.replace({name: 'me'})
      }
    },
    getResearchGroupInfo (customerNo) {
      // customerNo = EMKT.testCustomerNo
      // 获取所有的课题组信息
      this.gcapi('getResearchGroupInfoListByCustomerNo', customerNo).then(res => {
        if (res.body.result) {
          const researchGroupMemberMap = res.body.result.bResearchGroupMemberMap
          const researchGroupSet = res.body.result.bResearchGroupList
          this.UPDATE_RESEARCHGROUP_MEMBER_MAP(researchGroupMemberMap)
          this.UPDATE_RESEARCHGROUP_SET(researchGroupSet)
          console.log('researchGroupMemberMap', researchGroupMemberMap, researchGroupSet)
        }
      })
      // 过滤掉无效的任职关系
      this.gcapi('getWorkExperienceList', customerNo).then(res => {
        if (res && res.body.result) {
          const workList = res.body.result.filter(work => {
            return work.enable === true
          })
          EMKT.setStoreItem('EmktWorkExperienceList', workList)
        } else {
          EMKT.setStoreItem('EmktWorkExperienceList', [])
        }
        console.log('EmktWorkExperienceList', EMKT.getLocalStorage('EmktWorkExperienceList'))
      })
    },
    login () {
//       var _this = this
//       if (_this.account && _this.password) {
//         let param
//         if (_this.isSalesFlag) {
//           let cNo = _this.customerNo
//           if (!cNo) {
//             return
//           }
//           if (_this.errorFlag) {
//             return
//           }
//           param = {
//             'LoginId': _this.account,
//             'Password': md5(_this.password).toUpperCase(),
//             'CustomerNo': cNo
//           }
//         } else {
//           param = {
//             'LoginId': _this.account,
//             'Password': md5(_this.password).toUpperCase()
//           }
//         }
//         _this.gcapi('gcwwwifc/login', param).then((response) => {
//           if (response.body['code'] === 0) {
//             $.toast('登录成功')
//             _this.LOGIN_STATE_UPDATE(true)
//             _this.gcapi('gcwwwifc/getCustomerInfo').then(res => {
//               _this.CLIENT_INFO(res.body.result)
//               let customerNo = res.body.result.customerInfo.customerNo
//               let shareUrl = EMKT.wxShareUrl + '?introducer=' + customerNo
//               $.sign.shareUrl = shareUrl
//               _this.getResearchGroupInfo(customerNo)
//               var ShowPromotions = EMKT.getLocalStorage('EmktShowPromotions')
//               if (ShowPromotions && ShowPromotions !== null && ShowPromotions.length > 0) {
//                 var showPromotionParam = {}
//                 showPromotionParam.bPromotions = ShowPromotions
//                 showPromotionParam.customerNo = customerNo
//                 _this.gcapi('ShowPromotions', showPromotionParam).then((res) => {
//                   if (res.body.result === true) {
//                     var isshowPromotion = {}
//                     isshowPromotion.showPromotionParam = showPromotionParam
//                     isshowPromotion.show = true
//                     EMKT.setLocalStorage('isshowPromotion', isshowPromotion)
//                   }
//                 })
//               }
//               _this.gcapi('retrieveMyOrder').then((response) => {
//                 _this.MYORDER_UPDATE(response.body.result)
//                 // _this.$router.push('/me')
//               })
//               // EMKT.setLocalStorage('VipPlanList', null)
//               // if (_this.sessionInfo.customerInfo) {
//               //   var CustomerPlanParams = {
//               //     'CustomerNo': _this.sessionInfo.customerInfo.customerNo
//               //   }
//               //   this.gcapi('retrieveCustomerPlanInformation', CustomerPlanParams).then((response) => {
//               //     var VipPlanList = response.body.result
//               //     EMKT.setLocalStorage('VipPlanList', VipPlanList)
//               //   })
//               // }
//               _this.gcapi('getRecommendation', customerNo).then((res) => {
//                 // EMKT.setStoreItem('EmktPlain', merchList)
//                 if (res.body.result.length > 0) {
//                   var i = 0
//                   var list = []
//                   var newlist = res.body.result
//                   console.log(res.body.result)
//                   if (newlist.length > 15) {
//                     for (i = 0; i < 15; i++) {
//                       list.push(newlist[i])
//                     }
//                     EMKT.setStoreItem('EmktRecommendations', list)
//                   } else {
//                     EMKT.setStoreItem('EmktRecommendations', newlist)
//                   }
//                 }
//               })
//               EMKT.wxShare()
//               _this.$router.push(_this.fromFullPath)
//             })
// //            this.gcapi('searchContractNo').then(function (response) {
// //              EMKT.setLocalStorage('contractNO', null)
// //              console.log(response.body.result)
// //              EMKT.setLocalStorage('contractNO', response.body.result)
// //            })
//           } else {
//             $.toast(response.body['message'])
//           }
//         }, (response) => {
//           $.toast(response.body)
//         })
//       } else {
//         $.toast('请输入登录信息')
//       }
    },
    focus (id) {
      document.getElementById(id).focus()
    },
    deletePassword () {
      this.password = ''
    },
    toggleShowPassword () {
      this.showPassword = !this.showPassword
      if (this.showPassword) {
        $('#password').attr('type', 'text')
      } else {
        $('#password').attr('type', 'password')
      }
    }
  }
}
</script>

<style scoped>
  .ul {
    margin-bottom: 1rem;
    width: 90%;
    margin-left: 5%;
    border-radius: 5px;
    /*height: 60px;*/
    background: #C2DEFF;
    /*border-radius: 5px;*/
    border:none;
    height: 58px;
    line-height: 58px;
    display: inline-block;
  }
  .btn {
    background: #FFF;
  }
  .fontlogin {
    color: #606060;
    font-size: 1rem;
  }
  .fontcolor{
    color: #FFF;
    font-weight:300;
    font-size: 0.8rem;
  }
  .height {
    height: 58px;
  }
  .routerlink {
    float: left;
    width: 33.33%;
    /*display: table-cell;*/
  }
  .error{
    color: red;
  }
  .show-password {
    position: absolute;
    top: .6rem;
    right: 1rem;
    width: .9rem;
    height: .9rem;
  }
  .delete-password {
    position: absolute;
    top: .7rem;
    right: 2.3rem;
    width: .8rem;
    height: .8rem;
  }
  .block3 {
    display: flex;
    justify-content: center;
    text-align: center;
    font-size: 12px;
  }
  .left {
    margin-left: -15px;
    margin-right: 15px;
    line-height: 22px;
  }
  .right {
    margin-right: -15px;
  }
  .icon2{
    position: relative;
    top: 2px;
  }
  .bottom {
    position: fixed;
    bottom: 70px;
    width: 100vw;
  }
</style>



// WEBPACK FOOTER //
// Login.vue?50af8d58